export const NoAccessCard = ({ email, onSignOut }) => (
  <div className="flex min-h-screen items-center justify-center bg-mist px-6 font-manrope">
    <div
      data-testid="admin-no-access"
      className="w-full max-w-md rounded-[2rem] border border-forest/10 bg-white p-10 text-center shadow-xl"
    >
      <p className="font-syne text-2xl font-extrabold text-forest">
        Freshly<span className="text-fresh">.</span>
      </p>
      <h1 className="mt-6 font-syne text-2xl font-extrabold tracking-tight text-forest">
        No admin access
      </h1>
      <p className="mt-3 text-sm leading-relaxed text-forest/60">
        You&apos;re signed in as <span className="font-bold text-forest">{email}</span>, but this account
        isn&apos;t authorized for the admin dashboard.
      </p>
      <button
        type="button"
        onClick={onSignOut}
        data-testid="admin-no-access-signout"
        className="mt-8 h-12 w-full rounded-2xl bg-forest font-manrope text-sm font-bold text-bone transition-colors hover:bg-fresh"
      >
        Sign out
      </button>
    </div>
  </div>
);
